import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import {
  SaleTemplate,
  SaleTemplateCategory,
  SaleTemplateRequest,
} from '../../models/media/sale-template.model';
import { SettingsService } from '../../services/settings.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';

@Component({
  selector: 'app-sale-template-categories-popup',
  templateUrl: './sale-template-categories-popup.component.html',
  styleUrls: ['./sale-template-categories-popup.component.scss'],
})
export class SaleTemplateCategoriesPopupComponent
  extends BaseUnsubscribeComponent
  implements OnInit {
  @Input() public data: any;
  public isLoader: boolean;
  public saleTemplate: SaleTemplate = new SaleTemplate();
  form: FormGroup;
  searchText: string = '';
  constructor(
    public readonly modal: NgbActiveModal,
    private readonly settingService: SettingsService,
    private formBuilder: FormBuilder
  ) {
    super();
    this.form = this.formBuilder.group({
      saleTemplateId: [0],
      name: ['', Validators.required],
      isActive: [true],
      description: [''],
    });
  }

  ngOnInit(): void {
    this.getSaleTemplate();
  }
  public saveSaleTemplate() {
    if (this.form.valid) {
      const saleTemplate: SaleTemplate = this.form.value;
      const saleTemplateCategories: SaleTemplateCategory[] =
        this.saleTemplate.categoryIds?.map((x) => {
          return {
            mediaCategoryId: x,
            saleTemplateId: saleTemplate.saleTemplateId,
            saleTemplateCategoryId: 0,
            createdBy: 0,
            createdDate: new Date(),
          };
        });
      const template: SaleTemplateRequest = {
        saleTemplate: saleTemplate,
        saleTemplateCategories:
          this.saleTemplate.categoryIds == null ? [] : saleTemplateCategories,
      };
      this.isLoader = true;
      this.settingService
        .saveSaleTemplate(template)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((response) => {
          this.isLoader = false;
          this.modal.close(this.saleTemplate);
        });
    }
  }
  public getSelectedMediaIds(categoryIds: number[]) {
    this.saleTemplate.categoryIds = categoryIds;
    this.form.markAsDirty();
  }
  public getSaleTemplate(): void {
    this.settingService
      .getSaleTemplateById(this.data.template.saleTemplateId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        if (response) {
          this.saleTemplate = response;
          this.form.patchValue(this.saleTemplate);
        }
      });
  }

  public applyFilter(searchText: string) {
    this.searchText = searchText;
  }
}
